export default "__VITE_PUBLIC_ASSET__7f64f7cc__"